<template>
  <div v-if="isOpen" class="language-dropdown">
    <div class="dropdown-header"><span class="dropdown-title">Select Language</span></div>
    <div class="language-list">
      <div
        v-for="language in languages"
        :key="language.name"
        class="language-item"
        @click="selectLanguage(language)"
      >
        <div class="language-info">
          <span class="language-name">{{ language.name }}</span>
        </div>
        <img
          class="language-flag"
          :src="getLanguageFlagUrl(language.flag)"
        />
      </div>
    </div>
  </div>
</template>


<script setup>
import { ref } from 'vue'
import { useI18n } from 'vue-i18n'
import { languages, getLanguageFlagUrl } from '../config/languages.js'

const { locale, t } = useI18n()

const isOpen = ref(false)

const toggleDropdown = () => {
  isOpen.value = !isOpen.value
}

const selectLanguage = (language) => {
  locale.value = language.code
  localStorage.setItem('locale', language.code)
  isOpen.value = false
}

defineExpose({
  toggleDropdown,
  isOpen
})
</script>


<style>
.language-dropdown {
  position: absolute;
  top: 100%;
  right: 0;
  background-color: white;
  border-radius: 8px;
  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.15);
  min-width: 200px;
  z-index: 1000;
}

.dropdown-header {
  padding: 12px 16px;
  border-bottom: 1px solid #eee;
}

.dropdown-title {
  font-size: 14px;
  font-weight: 500;
  color: #333;
}

.language-list {
  max-height: 300px;
  overflow-y: auto;
}

.language-item {
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 12px 16px;
  cursor: pointer;
  transition: background-color 0.2s;
}

.language-item:hover {
  background-color: #f5f5f5;
}

.language-info {
  display: flex;
  align-items: center;
}

.language-name {
  font-size: 14px;
  color: #333;
}

.language-flag {
  width: 24px;
  height: 24px;
  border-radius: 50%;
  object-fit: cover;
}
</style>
